import { generateSearchQuery } from "@/utils/search";
import { ICustomer, ICustomerForm } from "../types";

/**
 * Generate search query for customers
 */
export const generateCustomersSearchQuery = (searchText: string): string => {
  return generateSearchQuery(searchText, [
    "name",
    "dogma_tradingname",
    "emailaddress1",
    "telephone1",
  ]);
};

/**
 * Generate status filter query for customers
 */
export const generateStatusFilterQuery = (statuscode: number | null | undefined): string => {
  if (statuscode === null || statuscode === undefined) {
    return "";
  }
  return `statuscode eq ${statuscode}`;
};

/**
 * Generate region filter query for customers
 */
export const generateRegionFilterQuery = (region: number | null | undefined): string => {
  if (region === null || region === undefined) {
    return "";
  }
  return `dogma_region eq ${region}`;
};

/**
 * Generate customer type filter query
 */
export const generateCustomerTypeFilterQuery = (customerType: number | null | undefined): string => {
  if (customerType === null || customerType === undefined) {
    return "";
  }
  return `customertypecode eq ${customerType}`;
};

/**
 * Generate credit terms (payment terms) filter query
 */
export const generateCreditTermsFilterQuery = (creditTerms: number | null | undefined): string => {
  if (creditTerms === null || creditTerms === undefined) {
    return "";
  }
  return `paymenttermscode eq ${creditTerms}`;
};

/**
 * Combine multiple filter queries with 'and' operator
 */
export const combineFilterQueries = (filters: string[]): string => {
  const validFilters = filters.filter(f => f && f.trim() !== '');
  return validFilters.length > 0 ? validFilters.join(' and ') : '';
};

/**
 * Transform customer data for form initialization
 */
export const transformCustomerForm = (record: ICustomer): ICustomerForm => {
  return {
    name: record.name,
    emailaddress1: record.emailaddress1,
    telephone1: record.telephone1 ?? "",
    // address1_line1: record.address1_line1,
    // address1_city: record.address1_city,
    // address1_postalcode: record.address1_postalcode,
    // address1_country: record.address1_country,
    statuscode: record.statuscode,
  };
};

/**
 * Transform form data for API submission
 */
export const transformCustomerFormForApi = (
  values: ICustomerForm
): ICustomerForm => {
  return {
    name: values.name,
    emailaddress1: values.emailaddress1,
    telephone1: values.telephone1,
    address1_line1: values.address1_line1,
    address1_city: values.address1_city,
    address1_postalcode: values.address1_postalcode,
    address1_country: values.address1_country,
    statuscode: values.statuscode,
  };
};
